export enum WorkflowStatusActionType {    
    DispositionUpdate = 0,
    followUpUpdate = 1,
    isInEmrUpdate = 2,
    sortOrderUpdate = 3,
    isRuledOutUpdate = 4,
    isILDAUpdate = 6,
    Delete = 5
}